export default "__VITE_PUBLIC_ASSET__9678a00f__"